export default __webpack_public_path__ + "static/media/level_3.060f7db6.png";